import styled from "styled-components";
import { motion } from "framer-motion";

export const Card = styled(motion.button)`
    width: 100%;
    height: 80px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 10px;
    border: none;
    background: transparent;
    border: thin solid var(--border-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 3px;
    color: var(--text-color);
    position: relative;
    cursor: pointer;

    :is([data-highlight = true]) {
        background: #5DA57D;
        background: -webkit-linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        background: -moz-linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        background: linear-gradient(90deg, rgba(93, 165, 125, 1) 0%, rgba(126, 189, 97, 1) 55%, rgba(126, 189, 97, 1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5DA57D", endColorstr="#7EBD61", GradientType=1);
        color: #fff;
    }

    p.Card__title {
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        padding: 0;
        margin: 0;
    };

    p.Card__value {
        font-weight: 700;
        font-size: 2.400vw;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: flex;
        align-items: center;
        line-height: 40px;
    }

    img.Card__icon {
        position: absolute;
        bottom: 10px;
        right: 10px;
        width: 40px
    }
`;